<template lang="pug">
b-modal#walletAdjustAffiliate(
  ref="walletAdjustAffiliate"
  :title="$t('ui.combine.wallet_adjust')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      //- DebounceInput(
      //-   size="sm"
      //-   ref="account_id"
      //-   required
      //-   type="text"
      //-   :dirty="$v.account_id.$dirty"
      //-   :error="$v.account_id.$error"
      //-   v-model.trim.lazy="$v.account_id.$model"
      //-   :disabled="loading"
      //- )
      //- ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      .disabled-input.form-control.form-control-sm
        span {{ account_id }}
        div.float-right
          span.font-weight-bold(:class="$helpers.fontClassName(wallet_balance)") {{ $n(wallet_balance, 'currency') }}
    b-form-group(:label="$t('ui.amount')").mb-0
      DebounceInput(
        size="sm"
        ref="amount"
        type="text"
        :dirty="$v.amount.$dirty"
        :error="$v.amount.$error"
        v-model.trim.lazy="$v.amount.$model"
        :disabled="loading"
      )
      span.small.text-info {{ $t("message.adjustWalletTooltips") }}
      ValidateResult(:value="$v.amount" :name="$t('ui.amount')")
    b-form-group(:label="$tc('ui.remark')").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model="remark"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      account_id: "",
      amount: "",
      remark: "",
      wallet_balance: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  validations: {
    account_id: {
      required,
      maxLength: maxLength(50)
    },
    amount: {
      required,
      decimal
    },
    remark: {
      required
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getMemberWalletAff: function() {
      let url = config.walletGetAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.isOperator ? this.accountID : this.operatorID,
        account_id: this.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.wallet_balance = response.data.dt[0]['cash_balance'];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.walletAdjustAffUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.isOperator ? this.accountID : this.operatorID,
          account_id: this.account_id,
          amount: this.amount,
          remark: this.remark
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.walletAdjustAffiliate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "wallet_adjust", this.feedback.status);
                  this.$refs.walletAdjustAffiliate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.amount = "";
      this.remark = "";
      this.wallet_balance = ""
      this.getMemberWalletAff();
      this.$refs.amount.$el.focus();
    }
  }
};
</script>

<style scoped>
.disabled-input {
  background-color: #e9ecef;
  opacity: 1;
}
</style>